import {default as Huddle} from "./Huddle"
import {default as HuddleRepository} from "./HuddleRepository"
import {httpClient} from "Config";

export const huddle = new Huddle()
export const huddleRepo = new HuddleRepository(httpClient)
